import { CONFIG } from '../../../config/mainConfig';
import { UserLocalStorageKeysEnum } from '../../../interfaces/user.interface';
import { callAPI } from '../../../services/api.service';
import { setCurrentStep } from '../../../store/appSlice';
import { Toast } from '../../Common/Toast';
import { AppDispatch } from '../../../store/store';

export const saveDraft = async (
  email: string | null,
  bookId: string,
  currentStep: number,
  dispatch: AppDispatch,
  setLoader: (loading: boolean) => void,
  setOpenDialog: (loading: boolean) => void
) => {
  try {
    setLoader(true);
    const response = await callAPI(`api/save-story-draft`, { email, bookId, step: currentStep });

    if (response?.bookId) {
      localStorage.removeItem(UserLocalStorageKeysEnum.BOOK_ID);
      localStorage.removeItem(UserLocalStorageKeysEnum.EDIT_MODE);
      localStorage.removeItem(UserLocalStorageKeysEnum.STORY_STEP);
      dispatch(setCurrentStep(0));

      Toast(response?.message, false);
      window.location.href = `${window.location.href}?${CONFIG.BROWSER_REFRESH_POPUP_PARAM}=no`;
      setTimeout(() => {
        window.location.reload();
      }, 500);
      setOpenDialog(false);
    } else {
      Toast('Unexpected Error While Saving book as Draft', true);
    }
  } catch (error) {
    setLoader(false);
    Toast('Unexpected Error While Saving book as Draft', true);
  } finally {
    setLoader(false);
  }
};